import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Checkbox } from '../Checkbox/Checkbox'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import './InputContainer.scss'

/*
function usePrevious (value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}
*/

export const InputContainer = ({
  buttonText,
  className,
  containerClassName,
  enablePressEnter,
  forceInvalid,
  hasInternalCheckbox,
  inputClassName,
  internalChechBoxLabel,
  internalChechBoxValue,
  invalidClassName,
  invalidMessage,
  isDisabled,
  isInvalid,
  isRequired,
  label,
  maxLength,
  name,
  notes,
  onChange,
  onKeyDown,
  onClickButton,
  onClickInternalCheckbox,
  placeholder,
  pressEnterCallback,
  type,
  value,
  'data-mu-test': dataAttributeTest,
  ...otherProps
}) => {
  const [isDirty, setIsDirty] = useState(false)

  const inputEl = useRef(null)

  const containerComponentClassName = classnames(
    containerClassName,
    'row m-bottom-0',
    {
      'c-input-container--invalid': isInvalid
    }
  )

  const inputContainerClass = classnames(className, buttonText, {
    'col-xs-7  p-left-0 p-right-0': hasInternalCheckbox,
    'copy-to-clipboard-btn_container': buttonText
  })

  const inputClass = classnames(inputClassName, {
    'ng-invalid': isInvalid,
    'ng-dirty': isDirty,
    'input-con-parametro_input is-left': hasInternalCheckbox
  })

  const invalidNotesClassName = classnames(
    'input_is-required_text',
    invalidClassName
  )

  function handleKeyUp(e) {
    setIsDirty(true)
  }

  useEffect(() => {
    if (value) {
      setIsDirty(true)
    }
  }, [value])

  function onKeyPress(event) {
    if (event) {
      if (enablePressEnter && event.key === 'Enter') {
        pressEnterCallback()
      }
    }
  }

  function handelOnClickInternalCheckbox(e) {
    onClickInternalCheckbox(e)
  }

  const propsInternalChechBox = {
    className: 'm-left m-right truncate',
    name: 'searchFullText',
    label: internalChechBoxLabel,
    labelClassName: 'text-light label-simple',
    onChange: handelOnClickInternalCheckbox,
    checked: internalChechBoxValue,
    disabled: isDisabled
  }

  return (
    <>
      <div className={containerComponentClassName}>
        {label && (
          <div className='row-label'>
            <label>{label}</label> {isRequired && <strong>*</strong>}{' '}
          </div>
        )}
        <div className={inputContainerClass}>
          <input
            ref={inputEl}
            className={inputClass}
            type={type}
            name={name}
            maxLength={maxLength}
            placeholder={placeholder}
            value={value}
            disabled={isDisabled}
            onChange={onChange}
            onKeyUp={handleKeyUp}
            onKeyDown={onKeyDown}
            required={isRequired}
            onKeyPress={onKeyPress}
            data-mu-test={classnames('input', dataAttributeTest)}
            {...otherProps}
          />

          {buttonText && (
            <CopyToClipboard onCopy={onClickButton} text={value}>
              <button className='button-reset copy-to-clipboard-btn copy-to-clipboard-btn_input-text'>
                {buttonText}
              </button>
            </CopyToClipboard>
          )}
        </div>
        {hasInternalCheckbox && (
          <div className='col-xs-5 p-left-0 p-right-0 truncate'>
            <div className='input-con-parametro_parametro is-right text-center'>
              {/* <div className='m-left container-checkbox test-searchInputFulltext truncate'>
              <input type='checkbox' id='searchFullText' name='searchFullText' checked={internalChechBoxValue} />
              <label className='label-simple' htmlFor='searchFullText' >{internalChechBoxLabel}</label>
            </div> */}
              <Checkbox
                {...propsInternalChechBox}
                data-mu-test={classnames(
                  dataAttributeTest && [`${dataAttributeTest}__checkbox`]
                )}
              />
            </div>
          </div>
        )}

        {notes && (
          <div className='row m-bottom-0'>
            <p className='input-note'>{notes}</p>
          </div>
        )}
        {(isDirty || forceInvalid) && isInvalid && invalidMessage && (
          <div className='row m-bottom-0'>
            <p className={invalidNotesClassName}>{invalidMessage}</p>
          </div>
        )}
      </div>
    </>
  )
}

InputContainer.defaultProps = {
  enablePressEnter: false,
  forceInvalid: false,
  internalChechBoxValue: false,
  invalidClassName: undefined,
  isDisabled: false,
  isInvalid: false,
  isRequired: false,
  maxLength: undefined,
  type: 'text'
}

InputContainer.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  enablePressEnter: PropTypes.bool,
  forceInvalid: PropTypes.bool,
  hasInternalCheckbox: PropTypes.bool,
  inputClassName: PropTypes.string,
  internalChechBoxLabel: PropTypes.string,
  internalChechBoxValue: PropTypes.bool,
  invalidClassName: PropTypes.string,
  invalidMessage: PropTypes.string,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  notes: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onClickButton: PropTypes.func,
  onClickInternalCheckbox: PropTypes.func,
  placeholder: PropTypes.string,
  pressEnterCallback: PropTypes.func,
  type: PropTypes.oneOf(['text', 'number']),
  value: PropTypes.node,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
